<template>
<div class="chapter">
<div class="inner_page">
<p class="SP"> </p>
<p class="FMEP">The American Practical Navigator,<span class="ePub-I"> first published in 1802 by Nathaniel Bowditch, is an encyclopedia of navigation. It serves as a valuable handbook on oceanography and meteorology, and contains useful tables and a maritime glossary. In 1867 the copyright and plates were bought by the Hydrographic Office of the United States Navy, and as a U.S. Government publication. The text has evolved with the advances in navigation practices since that first issue and continues to serve as a valuable reference for marine navigation in the modern day. It is considered one of America’s nautical institutions.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?76467892